import { InputByTypeProperties } from "@/models/form-builder-interface";
import { ConfirmableFieldAlias } from "@/models/field-confirmation-interface";

export type ConfirmationMode = true | false | 'optional' | 'if-filled';

export interface RegisterMemberProps {
  id?: string;
  profileFields?: string[];
  fieldTitles?: Record<string, string>;
  optionalFields?: string[];
  inputProperties?: InputByTypeProperties;
  forceFields?: Record<string, string>;
  otpConfirm?: Partial<Record<ConfirmableFieldAlias, ConfirmationMode>>;
  languageMode?: 'hidden_no_api' | 'hidden_auto' | 'editable_auto';
}

export const defaults = {
  profileFields: ['firstname', 'lastname', 'birth_date', 'country_id', 'region_id', 'email', 'password', 'password_confirm'],
  inputProperties: { noAutocomplete: true },
  languageMode: 'hidden_no_api' as const,
};
